// External Dependencies
import Marionette from 'backbone.marionette';
import Backbone from 'backbone';

// Internal Dependencies - screens/views/templates
import optedOutContainerView  from '../../../../templates/CCM/OptedOut/optedOutContainerView';
import OptedOutCompositeView from './OptedOutCompositeView';
import PatientTotalsView from '../PatientList/PatientTotalsView';

// Internal Dependencies - models/collections
import { OptedOutCollection } from './models/OptedOutCollection';

export default Marionette.LayoutView.extend({

	regions: {
		'optedOutContainerView': '.unenrolled-container-view',
		'patientTotals': '.patient-totals-container'
	},

	initialize: function() {
		this.channel = Backbone.Radio.channel( 'AppChannel' );
		this.app = this.channel.request( 'app' );
		this.collection = new OptedOutCollection();
	},

	getTemplate: function() {
		return optedOutContainerView( this.model );
	},

	onShow: function() {
		this.showChildView( 'optedOutContainerView', new OptedOutCompositeView({collection: this.collection}) );
		this.showChildView( 'patientTotals', new PatientTotalsView({collection: this.collection}) );
	}

});
